import produce from 'immer'
import { handleActions } from 'redux-actions'

import * as actions from './actions'

const addOrRemoveHandler = produce((draft, action) => {
  const { id } = action.payload
  const index = draft.findIndex(n => n.id === id)

  if (index !== -1) {
    draft.splice(index, 1)
  }

  if (action.type === actions.addNotification.toString()) {
    draft.push(action.payload)
  }
})

export * from './constants'
export * from './actions'
export * from './selectors'
export * from './hooks'

export default handleActions({
  [actions.addNotification]: addOrRemoveHandler,
  [actions.removeNotification]: addOrRemoveHandler,
  [actions.clearNotifications]: () => [],
}, [])
